(function (root) {
  'use strict';

  const LEAGUE_HUBS = {
    NFL: '/pages/nfl-new',
    NBA: '/pages/nba',
    NHL: '/pages/nhl',
    College: '/pages/college-new',
    WWE: '/collections/wwe',
  };
  const LEAGUES = new Set(['NFL', 'NBA', 'NHL', 'College']);
  const FAN_SHOP_PARENTS = new Set(['NFL', 'NBA', 'NHL', 'College', 'WWE']);
  const LIFESTYLE_HANDLE = 'lifestyle';
  const LIFESTYLE_HREF = '/collections/lifestyle';
  const ROOT_HUBS = [
    { pattern: /^Lifestyle$/i, title: 'LIFESTYLE', href: LIFESTYLE_HREF },
    { pattern: /^(Customize|Custom Socks)$/i, title: 'CUSTOMIZE', href: '/collections/custom-face-socks' },
    { pattern: /^Sale$/i, title: 'SALE', href: '/collections/sale' },
  ];
  const BRANCH_HUBS = {
    'dc comics': '/collections/dc-comics',
  };
  const FILTER_LABELS = {
    underwear: 'UNDERWEAR',
    'tie-back': 'HEADBANDS',
    customize: 'CUSTOM',
    collabs: 'COLLABS',
    'nfl-players': 'NFL PLAYERS',
  };
  let teamCatalogSource = null;
  let teamCatalogCache = [];

  function safePath(value) {
    return typeof value === 'string' && /^\/(?!\/)/.test(value) && !/[\\\s]/.test(value) ? value : '';
  }

  function destination(setting) {
    const url = setting && setting.url || {};
    const type = url.type && url.type.id;
    if (type === 'link') return safePath(url.link);
    if (type === 'page' && url.page && url.page.handle) return '/pages/' + encodeURIComponent(url.page.handle);
    if ((!type || type === 'collection') && url.collection && url.collection.handle) {
      return '/collections/' + encodeURIComponent(url.collection.handle);
    }
    return '';
  }

  function containsCollection(items, handle) {
    return (items || []).some(function (item) {
      const collection = item && item.setting && item.setting.url && item.setting.url.collection;
      return collection && collection.handle === handle || containsCollection(item && item.menus, handle);
    });
  }

  function collectionHandle(setting) {
    const href = destination(setting);
    const match = href.match(/^\/collections\/([^/?#]+)$/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function menuTitle(item) {
    return String(item && item.setting && item.setting.title || '')
      .replace(/^Mobile\s*-\s*/i, '')
      .trim();
  }

  function collectionPaths(item, handle, path, matches) {
    const nextPath = (path || []).concat(item);
    if (collectionHandle(item && item.setting) === handle) matches.push(nextPath);
    (item && item.menus || []).forEach(function (child) {
      collectionPaths(child, handle, nextPath, matches);
    });
    return matches;
  }

  function shopAllHref(item, title) {
    const wanted = String(title || '').replace(/[^a-z0-9]/gi, '').toLowerCase();
    let match = '';
    (function visit(node) {
      if (!node || match) return;
      const candidateTitle = menuTitle(node).replace(/^Shop All\s+/i, '');
      const candidate = candidateTitle.replace(/[^a-z0-9]/gi, '').toLowerCase();
      if (/^Shop All\s+/i.test(menuTitle(node)) && candidate === wanted) {
        match = destination(node.setting);
      }
      (node.menus || []).forEach(visit);
    })(item);
    return match;
  }

  function relatedCollectionHref(item, title) {
    const href = destination(item && item.setting);
    const handle = collectionHandle(item && item.setting);
    if (!href || !handle) return '';
    const titleTokens = new Set(String(title || '').toLowerCase().match(/[a-z0-9]+/g) || []);
    const handleTokens = handle.toLowerCase().match(/[a-z0-9]+/g) || [];
    return handleTokens.some(function (token) {
      return token.length > 2 && titleTokens.has(token);
    }) ? href : '';
  }

  function branchHubHref(roots, item) {
    const title = menuTitle(item);
    const peers = [];
    (function collect(nodes) {
      (nodes || []).forEach(function (node) {
        if (menuTitle(node).toLowerCase() === title.toLowerCase()) peers.push(node);
        collect(node.menus);
      });
    })(roots);

    for (const peer of peers) {
      const href = shopAllHref(peer, title);
      if (href) return href;
    }
    for (const peer of peers) {
      const href = relatedCollectionHref(peer, title);
      if (href) return href;
    }
    return BRANCH_HUBS[title.toLowerCase()] || '';
  }

  function menuCollectionTrail(data, handle) {
    const roots = (data && data.megamenu || []).slice().sort(function (a, b) {
      return Number(/^Mobile\s*-/i.test(a && a.setting && a.setting.title)) -
        Number(/^Mobile\s*-/i.test(b && b.setting && b.setting.title));
    });

    for (const hub of ROOT_HUBS) {
      const matchingRoots = roots.filter(function (rootNode) { return hub.pattern.test(menuTitle(rootNode)); });
      if (!matchingRoots.length) continue;
      const isRoot = matchingRoots.some(function (rootNode) {
        return collectionHandle(rootNode.setting) === handle;
      }) || handle === hub.href.replace('/collections/', '');
      if (isRoot || matchingRoots.some(function (rootNode) { return containsCollection(rootNode.menus, handle); })) {
        return { title: hub.title, href: hub.href, isLeagueRoot: isRoot };
      }
    }

    const popCultureRoots = roots.filter(function (rootNode) {
      return /^Pop Culture$/i.test(menuTitle(rootNode));
    });
    const paths = [];
    popCultureRoots.forEach(function (rootNode) {
      collectionPaths(rootNode, handle, [], paths);
    });
    paths.sort(function (a, b) { return b.length - a.length; });

    for (const path of paths) {
      for (let index = path.length - 2; index > 0; index -= 1) {
        const branch = path[index];
        const href = branchHubHref(popCultureRoots, branch);
        if (!href) continue;
        return {
          title: menuTitle(branch).toUpperCase(),
          href: href,
          isLeagueRoot: collectionHandle(branch.setting) === handle || href === '/collections/' + encodeURIComponent(handle),
        };
      }
    }
    return null;
  }

  function teamCatalog(data) {
    if (!data || !Array.isArray(data.megamenu)) return [];
    if (data === teamCatalogSource) return teamCatalogCache;
    const roots = data.megamenu.filter(function (item) {
      return /^(Mobile - )?Fan Shop$/i.test(item && item.setting && item.setting.title);
    }).sort(function (a, b) {
      return Number(/^Mobile - /i.test(a.setting.title)) - Number(/^Mobile - /i.test(b.setting.title));
    });
    const teams = [];
    const seenLeagues = new Set();

    roots.forEach(function (parent) {
      (parent.menus || []).forEach(function (league) {
        const leagueTitle = league && league.setting && league.setting.title;
        if (!LEAGUES.has(leagueTitle) || seenLeagues.has(leagueTitle)) return;
        seenLeagues.add(leagueTitle);

        (league.menus || []).forEach(function (column) {
          (column.menus || []).forEach(function (item) {
            const setting = item && item.setting;
            const href = destination(setting);
            const match = href.match(/^\/collections\/([^/?#]+)$/);
            const title = setting && String(setting.title || '').trim();
            if (!match || !title || /^(shop all|view all|menu item)/i.test(title)) return;
            teams.push({
              league: leagueTitle,
              title: title,
              handle: decodeURIComponent(match[1]),
            });
          });
        });
      });
    });

    teamCatalogSource = data;
    teamCatalogCache = teams.sort(function (a, b) { return b.handle.length - a.handle.length; });
    return teamCatalogCache;
  }

  function teamForProduct(product, data) {
    if (!product) return null;
    const handle = String(product.handle || '').toLowerCase();
    const title = String(product.title || '').toLowerCase();
    const tags = (product.tags || []).map(function (tag) { return String(tag).toLowerCase(); });
    const candidates = teamCatalog(data);

    return candidates.find(function (team) {
      const teamHandle = team.handle.toLowerCase();
      const teamTitle = team.title.toLowerCase();
      return handle === teamHandle || handle.indexOf(teamHandle + '-') === 0 ||
        title === teamTitle || title.indexOf(teamTitle + ' ') === 0 ||
        tags.includes(teamHandle) || tags.includes(teamTitle);
    }) || null;
  }

  function filterLabels(search) {
    const params = new URLSearchParams(search || '');
    const values = ['cs_collection', 'cs_format', 'cs_design'].flatMap(function (key) {
      return params.getAll(key).flatMap(function (value) { return value.split(','); });
    }).filter(function (value) { return /^[a-z0-9][a-z0-9-]{0,100}$/.test(value); });
    const labels = Array.from(new Set(values.map(function (value) {
      return FILTER_LABELS[value] || value.replace(/-/g, ' ').toUpperCase();
    })));
    return labels;
  }

  function filterTitle(search) {
    return filterLabels(search).join(' + ');
  }

  function filterSelection(search) {
    const labels = filterLabels(search);
    return {
      count: labels.length,
      title: labels.length === 1 ? labels[0] : '',
    };
  }

  function rootCurrentTitle(trail, selectedFilter, collectionTitle) {
    if (!trail || !trail.isLeagueRoot) return String(collectionTitle || '');
    if (selectedFilter) return selectedFilter;
    const title = String(collectionTitle || '').trim();
    return title.toUpperCase() === trail.title
      ? 'SHOP ALL ' + trail.title
      : title;
  }

  function lifestyleTrail(data, handle) {
    const trail = menuCollectionTrail(data, handle);
    return trail && trail.title === 'LIFESTYLE' ? trail : null;
  }

  function findCollectionTrail(data, handle) {
    if (!data || !Array.isArray(data.megamenu) || !handle) return null;
    const roots = data.megamenu.filter(function (item) {
      return /^(Mobile - )?Fan Shop$/i.test(item && item.setting && item.setting.title);
    }).sort(function (a, b) {
      return Number(/^Mobile - /i.test(a.setting.title)) - Number(/^Mobile - /i.test(b.setting.title));
    });

    for (const parent of roots) {
      for (const league of parent.menus || []) {
        const title = league && league.setting && league.setting.title;
        if (!FAN_SHOP_PARENTS.has(title)) continue;
        const leagueDestination = destination(league.setting);
        const isLeagueRoot = leagueDestination === '/collections/' + encodeURIComponent(handle);
        if (!isLeagueRoot && !containsCollection(league.menus, handle)) continue;
        const href = LEAGUE_HUBS[title] || destination(league.setting);
        if (href) return { title: title.toUpperCase(), href: href, isLeagueRoot: isLeagueRoot };
      }
    }
    return menuCollectionTrail(data, handle);
  }

  function render(nav) {
    const trail = findCollectionTrail(root.ArtomatorMenuData, nav.dataset.collectionHandle);
    nav.hidden = true;
    if (!trail) return;
    const selection = filterSelection(root.location && root.location.search);
    const currentTitle = trail.isLeagueRoot
      ? (selection.count > 1
        ? ''
        : rootCurrentTitle(trail, selection.title, nav.dataset.collectionTitle))
      : nav.dataset.collectionTitle;
    const parent = nav.querySelector('[data-link-tree-parent]');
    const separator = nav.querySelector('.cs-link-tree__separator');
    const current = nav.querySelector('[data-link-tree-current]');
    parent.href = trail.href;
    parent.textContent = trail.title;
    parent.title = trail.title;
    separator.hidden = !currentTitle;
    current.hidden = !currentTitle;
    current.textContent = currentTitle;
    current.title = currentTitle;
    nav.hidden = false;
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-collection-link-tree]').forEach(function (nav) {
      render(nav);
    });
  }

  const api = {
    findCollectionTrail: findCollectionTrail,
    filterTitle: filterTitle,
    filterSelection: filterSelection,
    rootCurrentTitle: rootCurrentTitle,
    destination: destination,
    teamCatalog: teamCatalog,
    teamForProduct: teamForProduct,
    lifestyleTrail: lifestyleTrail,
    menuCollectionTrail: menuCollectionTrail,
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.CollectionTeamFilter = {
    teams: function () { return teamCatalog(root.ArtomatorMenuData); },
    teamForProduct: function (product) {
      const nav = root.document && root.document.querySelector('[data-collection-link-tree]');
      const trail = findCollectionTrail(root.ArtomatorMenuData, nav && nav.dataset.collectionHandle);
      if (!trail || !trail.isLeagueRoot) return null;
      const team = teamForProduct(product, root.ArtomatorMenuData);
      return team && team.league.toUpperCase() === trail.title ? team : null;
    },
  };
  root.CollectionHierarchy = {
    isLifestyleRoot: function () {
      const nav = root.document && root.document.querySelector('[data-collection-link-tree]');
      return Boolean(nav && nav.dataset.collectionHandle === LIFESTYLE_HANDLE);
    },
  };
  if (!root.document) return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  if (!root.CollectionLinkTreeRegistered) {
    root.CollectionLinkTreeRegistered = true;
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
    root.addEventListener('cs:filters-changed', function () { init(document); });
    root.addEventListener('popstate', function () { init(document); });
  }
})(typeof window === 'undefined' ? {} : window);
